import React from 'react';
import './NoOrder.css'; // Import the CSS file for styling

function NoOrder() {
    return (
        <div className="no-order-container">
            <p>You do not have any orders yet, try premium now.</p>
        </div>
    );
}

export default NoOrder;
